<app-aumico-layout>
    <ng-container header>
        <div>
            <span class="title">Annotations</span>
        </div>
    </ng-container>
    <ng-container content>
        <div *ngFor="let annotation of taskAnnotations" class="annotations">
            <span class="data">
                <span>{{ annotation.content }}</span>
                <span class="date">{{ annotation.createdAt | date }}</span>
            </span>
            <ham-button
                class="button"
                variant="primary"
                type="submit"
                outline="true"
                (click)="deleteAnnotation(annotation.id)"
            >
                Delete
            </ham-button>
            <ham-button
                class="button"
                variant="primary"
                type="submit"
                outline="true"
                (click)="updateAnnotation(annotation.id)"
            >
                Update
            </ham-button>
        </div>
        <div class="create-annotation">
            <ham-button class="button" variant="primary" type="submit" outline="true" (click)="createAnnotation()">
                Create
            </ham-button>
        </div>
        <div class="create-annotation" *ngIf="totalCount > taskAnnotations.length">
            <ham-button class="button" variant="primary" type="submit" outline="true" (click)="loadMore()">
                Load More
            </ham-button>
        </div>
    </ng-container>
</app-aumico-layout>
